
import { Component, Prop, Mixins } from "vue-property-decorator";
import EmployeeDetails from "../modals/employee-details.vue"
import { mapState } from "vuex";
import { ShiftStatus, SubscriptionStatus } from "@/common/constants";
import { ShiftDataDto } from "@/types/shift.type";
import ShiftMixin from "../shift.mixin";
import { EmployeeInfo, RequestedShift, RequestedWorker } from "../shift.types";
import { OfficeDto } from "@/types/office.type";
import { PayrollType } from "@/types/enums.type";

@Component({
  components: {
    EmployeeDetails
  },
  computed: {
    ...mapState("Shift", ["selectedOffice", "shiftData"])
  }
})
export default class RequestedCard extends Mixins(ShiftMixin) {
  @Prop() shift!: RequestedShift;

  selectedOffice!: OfficeDto;
  shiftData!: ShiftDataDto;

  employeeInfo: EmployeeInfo | null = null;
  modalShow = false;

  ShiftStatus = ShiftStatus;

  getClasses(val: boolean): string[] {
    return val ? ['fas', 'fa-check-circle'] : ['far', 'fa-circle'];
  }

  get eodValue(): boolean {
    return this.selectedOffice.payroll?.type === PayrollType.EndOfDay;
  }

  get headerText(): string {
    return this.shift.requestedWorkers.length > 1 
      ? 'Yatzee! We have found multiple people that want to help.'
      : 'Bingo! We have found someone who want to help.';
  }

  get details(): string {
    return [
      this.shift.date.toLocaleDateString("en-US", {
        weekday: 'long',
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      }), 
      this.shift.position,
      this.shift.time,
      this.shift.rate
    ].join(' · ')
  }

  getEmployeeDetails(details: RequestedWorker): void {
    this.employeeInfo = {
      id: details.userId,
      name: details.name,
      timeIn: this.getTimes(this.shift.time, 0, " - "),
      timeOut: this.getTimes(this.shift.time, 1, " - "),
      position: this.shift.position,
      rate: this.shift.rate,
      initials: this.getInitials(details.name),
      officeId: this.shift.officeId,
      email: details.email,
      phone: details.phone,
      rating: details.rating,
      date: this.shift.date,
      isFavorite: details.isFavorite,
    };

    this.modalShow = true;
  }

  submit(userId: number, shiftResponseId: number): void {
    this.$emit('submit', userId, shiftResponseId);
  }

  onDelete(): void {
    this.$emit('delete');
  }
}
